import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryServicePage,
  buildIndustryServiceHead,
} from "@/components/IndustryServicePage";
import { getIndustryServiceCombo } from "@/lib/industryServiceData";

const combo = getIndustryServiceCombo("seo", "plumbing")!;

export const Route = createFileRoute("/seo-for-plumbing")({
  head: () => buildIndustryServiceHead(combo),
  component: () => <IndustryServicePage combo={combo} />,
});
